import {stringIsWhiteSpace} from "@wix/devzai-utils-common";
import type {Extensions, JSONContent} from "@tiptap/core";
import {generateHTML} from "@tiptap/html";

export {default as RichTextExtensionBlockquote} from "@tiptap/extension-blockquote";
export {default as RichTextExtensionBold} from "@tiptap/extension-bold";
export {default as RichTextExtensionBulletList} from "@tiptap/extension-bullet-list";
export {default as RichTextExtensionCode} from "@tiptap/extension-code";
export {default as RichTextExtensionCodeBlock} from "@tiptap/extension-code-block";
export {default as RichTextExtensionDocument} from "@tiptap/extension-document";
export {default as RichTextExtensionHardBreak} from "@tiptap/extension-hard-break";
export {default as RichTextExtensionHeading} from "@tiptap/extension-heading";
export {default as RichTextExtensionHistory} from "@tiptap/extension-history";
export {default as RichTextExtensionHorizontalRule} from "@tiptap/extension-horizontal-rule";
export {default as RichTextExtensionItalic} from "@tiptap/extension-italic";
export {default as RichTextExtensionListItem} from "@tiptap/extension-list-item";
export {default as RichTextExtensionOrderedList} from "@tiptap/extension-ordered-list";
export {default as RichTextExtensionParagraph} from "@tiptap/extension-paragraph";
export {default as RichTextExtensionStrike} from "@tiptap/extension-strike";
export {default as RichTextExtensionText} from "@tiptap/extension-text";
export {default as RichTextExtensionLink} from "@tiptap/extension-link";
export type {Extensions as RichTextExtensions, JSONContent as RichTextJsonContent} from "@tiptap/core";

export type RichTextContent = string | JSONContent;

export function richTextContentIsNullableOrWhiteSpace (
    richTextContent: RichTextContent | undefined | null,
    richTextExtensions: Extensions
) {

    if (richTextContent === undefined || richTextContent === null) {
        return true;
    }

    const richTextContentStr = typeof richTextContent === 'string' ? richTextContent : generateHTML(richTextContent, richTextExtensions);

    return stringIsWhiteSpace(richTextContentStr)
}